const $inject = ['$compile'];
const lbaDynamic = function ($compile) {
  return {
    restrict: 'A',
    replace: false,
    //terminal: true,  // might need these lines if compile issues occur
    //priority: 1000,
    link: function (scope, element, attrs) {
      element.attr(scope.$eval(attrs.lbaDynamic), '');

      element.removeAttr('lba-dynamic');

      $compile(element)(scope);
    }
  };
};

lbaDynamic.$inject = $inject;

export default lbaDynamic;



// WEBPACK FOOTER //
// ./src/components/lbaDynamic/lbaDynamicDir.js